import React from "react";
import About from "../../Components/About/About";
import Banner from "../../Components/Banner/Banner";
import Contact from "../../Components/Contact/Contact";
import Feature from "../../Components/Feature/Feature";
import Footer from "../../Components/Footer/Footer";
import NavBar from "../../Components/Navbar/NavBar";
import Projects from "../../Components/Projects/Projects";
import Skills from "../../Components/Skills/Skills";
import MessengerCustomerChat from "react-messenger-customer-chat";
import Blogs from "../../Components/Blogs/Blogs";
import HireMe from "../../Components/HireMe/HireMe";

const Layout = () => {
  return (
    <>
      <NavBar />
      <Banner />
      {/* <HireMe /> */}
      <About />
      <Feature />
      <Skills />
      <Projects />
      <Blogs />
      <Contact />
      <MessengerCustomerChat
        pageId={process.env.REACT_APP_FB_PAGE_ID}
        appId={process.env.REACT_APP_FB_APP_ID}
      />
      <Footer />
    </>
  );
};

export default Layout;
